import { render } from "./ParceiroDashboard.vue?vue&type=template&id=5c6b5b90&scoped=true"
import script from "./ParceiroDashboard.vue?vue&type=script&lang=js"
export * from "./ParceiroDashboard.vue?vue&type=script&lang=js"

import "./ParceiroDashboard.vue?vue&type=style&index=0&id=5c6b5b90&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6b5b90"]])

export default __exports__